import { createContext, useContext, useState, useCallback } from 'react';

// Componentes
import Loader from '../components/Loader/Loader';

const LoaderContext = createContext();

export function LoaderProvider({ children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState('Carregando');

    const showLoader = useCallback((customMessage = 'Carregando') => {
        setMessage(customMessage);
        setIsLoading(true);
    }, []);

    const hideLoader = useCallback(() => setIsLoading(false), []);

    return (
        <LoaderContext.Provider value={{ showLoader, hideLoader }}>
            {children}
            {isLoading && <Loader message={message} />}
        </LoaderContext.Provider>
    );
}

export function useLoader() {
    return useContext(LoaderContext);
}